import { render, staticRenderFns } from "./LoyaltyCardExchange.vue?vue&type=template&id=24236e04&scoped=true&"
import script from "./LoyaltyCardExchange.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCardExchange.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=24236e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24236e04",
  null
  
)

export default component.exports